const translations = {
  "en": {
    "Competition": "Competition",
    "Fundamental": "Fundamental",
    "Growth": "Growth",
    "Momentum": "Momentum",
    "Tokenomics": "Tokenomics",
    "Valuation": "Valuation"
  },
  "zh-tw": {
    "Competition": "競爭",
    "Fundamental": "基本面",
    "Growth": "成長",
    "Momentum": "動能",
    "Tokenomics": "代幣經濟",
    "Valuation": "估值"
  }
};

export default translations;
